import { OWNER } from '../constants/RoutingTypes';
import { setFallback } from '../utils/buildRoutingRules';
import RoutingRuleBase from './RoutingRuleBase';
export default class OwnerRoutingRules extends RoutingRuleBase({
  '@type': OWNER,
  fallback: null
}, 'OwnerRoutingRules') {
  constructor(options) {
    super(setFallback(options));
  }
}